Ext.define('SA.Image', {
    singleton: true,

    load(src) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject();
            img.src = src;
        });
    }
});